import React from "react";

const NonceConcept = props => {
  return (
    <div>
      <p className="step-p"> 
        To mine another block to the blockchain, fill out the data input and click the button.
      </p>
    </div>
  );
};

export default NonceConcept;


// WEBPACK FOOTER //
// ./src/steps/add-block/concept.js